import React from 'react';

import LinkTextComponent from '../linkTextComponent/linkTextComponent';
import PillComponent from '../../pillComponent/pillComponent';
import QuestionWithTooltipComponent from '../questionWithTooltipComponent/questionWithTooltipComponent';
import UpgradeComponent from '../upgradeComponent/upgradeComponent';

import './titleComponentV2.css';

const TitleComponentV2 = ({
  showDisabledUI = false,
  billingPlanFeature = null,
  linkTxt = 'Read more.',
  linkUrl,
  pillType = null,
  titleTxt,
  toolTipPosition = 'right',
  toolTipTxt,
}) => {
  return (
    <div
      className={`et-v2-title-component-container ${showDisabledUI ? 'et-v2-title-component-container-disabled' : ''}`}>
      <div className="et-v2-tc-title-component-title-txt">
        {titleTxt}
        {linkUrl && <LinkTextComponent linkTxt={linkTxt} linkUrl={linkUrl} />}
      </div>
      {toolTipTxt && (
        <div className="et-v2-tc-title-component-tooltip-wrap">
          <QuestionWithTooltipComponent
            toolTipPosition={toolTipPosition}
            toolTipTxt={toolTipTxt}
          />
        </div>
      )}
      <UpgradeComponent isCrown billingPlanFeature={billingPlanFeature} />
      {pillType && <PillComponent pillType={pillType} />}
    </div>
  );
};

export default TitleComponentV2;
